import routes from "@/router/menu";
export default {
  computed: {
    enumerableRoutes() {
      const { path } = this.$route;
      return routes.filter((route) => route.path != path);
    },
  },
};
